import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { commaSeparateNumber } from '@helpers/number';
export var EMPTY_BASKET_TOTALS = {
  basketBaseTotal: 0,
  basketFinalTotal: 0,
  basketTotalDiscount: 0
};
export var hasPriceDiscount = function hasPriceDiscount(basePrice, finalPrice) {
  return finalPrice < basePrice;
};
export var normalizeBasketItem = function normalizeBasketItem(item) {
  var _ref, _item$basePrice, _ref2, _item$finalPrice, _item$quantity, _item$availablePrices;

  var basePrice = Number((_ref = (_item$basePrice = item.basePrice) !== null && _item$basePrice !== void 0 ? _item$basePrice : item.price) !== null && _ref !== void 0 ? _ref : 0);
  var finalPrice = Number((_ref2 = (_item$finalPrice = item.finalPrice) !== null && _item$finalPrice !== void 0 ? _item$finalPrice : item.price) !== null && _ref2 !== void 0 ? _ref2 : basePrice);
  return _objectSpread(_objectSpread({}, item), {}, {
    basePrice: basePrice,
    finalPrice: finalPrice,
    price: finalPrice,
    quantity: Number((_item$quantity = item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 1),
    availablePrices: (_item$availablePrices = item.availablePrices) !== null && _item$availablePrices !== void 0 ? _item$availablePrices : []
  });
};
export var calculateBasketTotalsFromItems = function calculateBasketTotalsFromItems(items) {
  var totals = items.reduce(function (acc, item) {
    var _item$quantity2, _ref3, _item$basePrice2, _ref4, _item$finalPrice2;

    var quantity = (_item$quantity2 = item.quantity) !== null && _item$quantity2 !== void 0 ? _item$quantity2 : 1;
    acc.basketBaseTotal += ((_ref3 = (_item$basePrice2 = item.basePrice) !== null && _item$basePrice2 !== void 0 ? _item$basePrice2 : item.price) !== null && _ref3 !== void 0 ? _ref3 : 0) * quantity;
    acc.basketFinalTotal += ((_ref4 = (_item$finalPrice2 = item.finalPrice) !== null && _item$finalPrice2 !== void 0 ? _item$finalPrice2 : item.price) !== null && _ref4 !== void 0 ? _ref4 : 0) * quantity;
    return acc;
  }, _objectSpread({}, EMPTY_BASKET_TOTALS));
  totals.basketTotalDiscount = totals.basketBaseTotal - totals.basketFinalTotal;
  return totals;
};
export var applyPriceRatio = function applyPriceRatio(basePrice, ratio) {
  if (ratio == null || ratio >= 1) {
    return basePrice;
  }

  return Math.round(basePrice * ratio * 100) / 100;
};
export var formatPriceAmount = function formatPriceAmount(amount) {
  return "".concat(commaSeparateNumber(amount), " \u20BD");
};